"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequireFacility = RequireFacility;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
var react_router_dom_1 = require("react-router-dom");
var use_my_facilities_1 = require("../../hooks/use-my-facilities");
var hooks_1 = require("../../store/hooks");
var no_facility_state_1 = require("../facility/no-facility-state");
var loader_1 = require("../loader");
var button_component_1 = require("../ui/button-component");
var text_component_1 = require("../ui/text-component");
function RequireFacility() {
    var activeFacility = (0, hooks_1.useAppSelector)(function (state) { return state.facility.facility; });
    var _a = (0, use_my_facilities_1.useMyFacilities)(), facilities = _a.facilities, isError = _a.isError, hasLoaded = _a.hasLoaded, refetch = _a.refetch;
    if (isError) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center gap-3 py-24 text-center", children: [(0, jsx_runtime_1.jsx)(react_1.Icon, { icon: "solar:danger-circle-linear", fontSize: 40, className: "text-medium-gray" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", center: true, label: "Failed to load your facilities. Please try again." }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Retry", variant: "secondary", onPress: function () { return refetch(); } })] }));
    }
    if (!hasLoaded) {
        return (0, jsx_runtime_1.jsx)(loader_1.Loader, { label: "Loading facilities" });
    }
    if (!facilities.length && !activeFacility) {
        return (0, jsx_runtime_1.jsx)(no_facility_state_1.NoFacilityState, {});
    }
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {});
}
